import { ModalContextProvider } from "contexts/ModalContext";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { GlobalTemplateProps } from "./GlobalTemplate.d";

export const GlobalTemplate = (props: GlobalTemplateProps) => {
  const { story } = props;

  const globalComponentBody = story.content.global || [];

  return <ModalContextProvider>{renderDynamicComponent(globalComponentBody)}</ModalContextProvider>;
};
